import { useQuery } from '@tanstack/react-query';
import { bulkRequestCount } from '../api/bulkRequests';
import { usePermission } from '../auth/usePermission';
import { BULK_REQUESTS_COUNT_QUERY_KEY } from '../pages/candidates/BulkRequestApprovals';

/**
 * Pending bulk-request count for the sidebar badge. Polled, like the other request-queue
 * badges — see useStepApprovalCount.js.
 */
export function useBulkRequestCount() {
  const { can } = usePermission();
  const enabled = can('candidates.bulk-request-approvals');

  const query = useQuery({
    queryKey: BULK_REQUESTS_COUNT_QUERY_KEY,
    queryFn: bulkRequestCount,
    enabled,
    refetchInterval: 60_000,
  });

  return enabled ? (query.data ?? 0) : 0;
}
